import React, { Component } from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl
} from "react-bootstrap";

export default class Create extends Component {
    render () {
        let {
            actions,
            
            promoCategory
        } = this.props;

        return (
            <div>
                <FormGroup>
                    <ControlLabel>Promo Category</ControlLabel>
                    <FormControl
                        value={promoCategory}
                        onChange={(e) => {
                            actions.setValue({
                                promoCategory: e.target.value
                            });
                        }}
                    />
                </FormGroup>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/EVoucherPromoCategory/FormContainer/Create.js